import { OnInit, Component, Input } from '@angular/core';
import { ToastService } from '@shared/services/toast.service';
import { ModalController } from '@ionic/angular';
import { Sensor } from '@models/sensor';
import { GroundSensor } from '@models/sensor/ground.sensor';
import { DevicesService } from '../../../views/main/intranet/devices/devices.service';
import { TensiometerSensor } from '@models/sensor/tensiometer.sensor';
import { AmbientSensor } from '@models/sensor/ambient.sensor';
import { HumidificationSensor } from '@models/sensor/humidification.sensor';
import { WaterPotentialSensor } from '@models/sensor/waterpotencial.sensor';
import { PreassureSensor } from '@models/sensor/preassure.sensor';
import { PluviometerSensor } from '@models/sensor/pluviometer.sensor';
import { PulseSensor } from '@models/sensor/pulse.sensor';
import { LevelSensor } from '@models/sensor/level.sensor';
import { WaterConductivitySensor } from '@models/sensor/waterconductivity.sensor';
import { NpkSensor } from '@models/sensor/npk.sensor';
import { PhSensor } from '@models/sensor/ph.sensor';
import { LimitType, Limit, NotificationType } from '@models/device';
import { LimitService } from '@shared/services/limit.services';
import { Atmos22Sensor } from '@models/sensor/atmos22.sensor';
import { Ig31Sensor } from '@models/sensor/ig31.sensor';
import { Ig71Sensor } from '@models/sensor/ig71.sensor';
import { Mec10Sensor } from '@models/sensor/mec10.sensor';
import { Wnk80ma_010Sensor } from '@models/sensor/wnk80ma-010.sensor';
import { Wnk80ma_05Sensor } from '@models/sensor/wnk80ma-05.sensor';
import { AcclimaTdr315hSensor } from '@models/sensor/acclima_tdr315h.sensor';
import { WindSpeedAttribute } from '@models/sensor_attribute/windSpeed.attribute';
import { WindDirectionAttribute } from '@models/sensor_attribute/windDirection.attribute';
import { AirTemperatureAttribute } from '@models/sensor_attribute/airTemperature.attribute';
import { MatricPotentialAttribute } from '@models/sensor_attribute/matricPotential.attribute';
import { SoilTemperatureAttribute } from '@models/sensor_attribute/soilTemperature.attribute';
import { SoilPhAttribute } from '@models/sensor_attribute/soilPh.attribute';
import { SoilMoistureAttribute } from '@models/sensor_attribute/soilMoisture.attribute';
import { SoilEcAttribute } from '@models/sensor_attribute/soilEc.attribute';
import { RadiationAttribute } from '@models/sensor_attribute/radiation.attribute';
import { ParFarRedAttribute } from '@models/sensor_attribute/parFarRed.attribute';
import { FarRedAttribute } from '@models/sensor_attribute/farRed.attribute';
import { PriAttribute } from '@models/sensor_attribute/pri.attribute';
import { HumidityAttribute } from '@models/sensor_attribute/humidity.attribute';
import { AtmPressureAttribute } from '@models/sensor_attribute/atmPressure.attribute';
import { CntTotalAttribute } from '@models/sensor_attribute/cntTotal.attribute';
import { CntParcialAttribute } from '@models/sensor_attribute/cntParcial.attribute';
import { TipoSenAbatAttribute } from '@models/sensor_attribute/tipoSenAbat.attribute';
import { WaterEcAttribute } from '@models/sensor_attribute/waterEc.attribute';
import { WaterTemperatureAttribute } from '@models/sensor_attribute/waterTemperature.attribute';
import { DepthAttribute } from '@models/sensor_attribute/depth.attribute';
import { CalWatsAttribute } from '@models/sensor_attribute/calWats.attribute';
import { Co2Attribute } from '@models/sensor_attribute/co2.attribute';
import { CondAttribute } from '@models/sensor_attribute/cond.attribute';
import { TempAttribute } from '@models/sensor_attribute/temp.attribute';
import { PhAttribute } from '@models/sensor_attribute/ph.attribute';
import { RawAttribute } from '@models/sensor_attribute/raw.attribute';
import { DewPointAttribute } from '@models/sensor_attribute/dewPoint.attribute';
import { DpvAttribute } from '@models/sensor_attribute/dpv.attribute';
import { WaterPluviometerAttribute } from '@models/sensor_attribute/waterPluviemeter.attribute';
import { WaterCounterPulseAttribute } from '@models/sensor_attribute/waterCounterPulse.attribute';
import { LeafTemperatureAttribute } from '@models/sensor_attribute/leaf-temperature.attribute';
import { LeafWetnessAttribute } from '@models/sensor_attribute/leaf-wetness.attribute';
import { PressureAttribute } from '@models/sensor_attribute/pressure.attribute';
import { WaterLevelAttribute } from '@models/sensor_attribute/water-level.attribute';
import { VoltageAttribute } from '@models/sensor_attribute/voltage.attribute';
import { MilliAmpsAttribute } from '@models/sensor_attribute/milli-amps.attribute';
import { WaterAttribute } from '@models/sensor_attribute/water.attribute';
import { PrecipitationECAttribute } from '@models/sensor_attribute/precipitation-ec.attribute';
import { VaporPressureAttribute } from '@models/sensor_attribute/vapor-pressure.attribute';

@Component({
  template: ''
})
export class SensorLimitBaseComponent implements OnInit {
  public type: LimitType;
  public color: string;
  @Input() modeCreateLimit: boolean = false;
  @Input() modeEditLimit: boolean = false;
  @Input() modeEditNoti: boolean = false;
  @Input() modeDelete: boolean = false;
  @Input() currentLilmits: Limit[] = [];
  public options: {
    title: string,
    value: string
  }[];
  public selectedSensor: Sensor = null;
  public position: number = -1;

  @Input() deviceId: string = null;
  @Input() data: Limit;
  @Input() sensors: Sensor[] = [];
  public form = null;
  public isSaving: boolean = false;
  location: any;

  constructor(
    private devicesService: DevicesService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private limitService: LimitService
  ) {
    this.options = [];
  }

  ngOnInit(): void {
    if (this.data && !this.modeDelete) {
      this.color = this.data.colorCode;
    }

    if (!this.modeDelete) {
      this.getOptions();
    }
  }

  getOptions(): void {
    // Validar si `this.sensors` es un array válido
    if (!Array.isArray(this.sensors) || this.sensors.length === 0) {
      this.options = []; // Asegúrate de inicializar `this.options` como vacío en caso de error
      return;
    }

    let tmpOptions: {
      title: string,
      value: string
    }[] = [];
    for (const sensor of this.sensors) {
      if (sensor && sensor.type) { // Validar que sensor y sensor.type existen
        tmpOptions = tmpOptions.concat(this._getOptionType(sensor.type));
      } else {
        console.warn('Sensor inválido encontrado:', sensor);
      }
    }
    this.options = tmpOptions.filter((value, index, self) =>
      index === self.findIndex((t) => (t.value === value.value))
    );
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  onChangeVisibility(event): void {
    this.form.value.isVisible = event.checked;
  }

  saveLimit(): void {
    this.isSaving = true;
    const data = this.form.value;
    data.type = this.type;
    data.colorCode = this.color ?? '#000';
    data.isVisible = data.isVisible ?? false;
    if (this.modeCreateLimit) {
      data.notificationType = NotificationType.NO_NOTIFY;
    }

    if (this.selectedSensor) {
      data.deviceSensorId = this.selectedSensor.id;
    }

    if (this.isEdit()) {
      this.updateLimit(data);
    } else {
      this.newLimit(data);
    }
  }

  changeSensor(event): void {
    const sensorPosition: number = event.value;
    this.selectedSensor = this.sensors.find((s) => s.position == sensorPosition);
  }

  confirmSave(response): void {
    this.toastService.successToast('Guardado correctamente');
  }

  updateLimit(data): void {
    this.devicesService.updateLimit(this.deviceId, this.data.id, data).subscribe(
      (response) => {
        const index = this.currentLilmits.findIndex((cl) => cl.id == response.id);
        if (index > -1) {
          this.currentLilmits[index] = response;
        }
        this.confirmSave(response);
        this.limitService.notifyLimitOrRangeChanged(); // Notificar que hubo cambios

      },
      (error) => {
        this.toastService.errorToast('Ha habido un error al guardar los datos. Inténtelo de nuevo más tarde');
        this.isSaving = false;
      },
      () => this.modalCtrl.dismiss()
    )
  }

  newLimit(data): void {
    this.devicesService.saveLimit(this.deviceId, data).subscribe(
      (response) => {
        this.currentLilmits.push(response);
        this.confirmSave(response);
        this.limitService.notifyLimitOrRangeChanged(); // Notificar que hubo cambios

      },
      (error) => {
        this.toastService.errorToast('Ha habido un error al guardar los datos. Inténtelo de nuevo más tarde');
        this.isSaving = false;
      },
      () => this.modalCtrl.dismiss()
    )
  }

  deleteLimit(): void {
    this.devicesService.deleteLimit(this.deviceId, this.data.id).subscribe(
      (response) => {
        const index = this.currentLilmits.findIndex((cl) => cl.id == this.data.id);
        if (index > -1) {
          this.currentLilmits[index] = response;
        }
        this.currentLilmits.splice(index, 1);
        this.confirmSave(response);
        this.limitService.notifyLimitOrRangeChanged(); // Notificar que hubo cambios

      },
      (error) => {
        this.toastService.errorToast('Ha habido un error al guardar los datos. Inténtelo de nuevo más tarde');
        this.isSaving = false;
      },
      () => this.modalCtrl.dismiss()
    )
  }

  getSensors(): Sensor[] {
    const sensors: Sensor[] = [];
    for (const sensor of this.sensors) {
      const tmpOptions = this._getOptionType(sensor.type);
      const res = tmpOptions.find((option) => {
        return option.value == this.data.property
      });

      if (res) {
        sensors.push(sensor);
      }
    }
    return sensors;
  }

  isNoti(): boolean {
    return this.modeEditNoti && !this.modeDelete;
  }

  isEdit(): boolean {
    return (this.modeEditLimit || this.modeEditNoti) && !this.modeDelete;
  }

  isDelete(): boolean {
    return this.modeDelete;
  }

  _getOptionType(type) {
    let tmpOptions: {
      title: string,
      value: string
    }[] = [];
    switch (type) {
      case 1:
        tmpOptions = GroundSensor.getVariables();
        break;
      case 2:
        tmpOptions = TensiometerSensor.getVariables();
        break;
      case 3:
        tmpOptions = AmbientSensor.getVariables();
        break;
      case 4:
        tmpOptions = HumidificationSensor.getVariables();
        break;
      case 5:
        tmpOptions = WaterPotentialSensor.getVariables();
        break;
      case 6:
        tmpOptions = PreassureSensor.getVariables();
        break;
      case 7:
        tmpOptions = PluviometerSensor.getVariables();
        break;
      case 8:
        tmpOptions = PulseSensor.getVariables();
        break;
      case 9:
        tmpOptions = LevelSensor.getVariables();
        break;
      case 10:
        tmpOptions = WaterConductivitySensor.getVariables();
        break;
      case 11:
        tmpOptions = NpkSensor.getVariables();
        break;
      case 12:
        tmpOptions = PhSensor.getVariables();
        break;
      case 13:
        tmpOptions.push(...WindSpeedAttribute.getVariables());
        tmpOptions.push(...WindDirectionAttribute.getVariables());
        tmpOptions.push(...AirTemperatureAttribute.getVariables());
        // tmpOptions = Atmos22Sensor.getVariables();
        break;
      case 14:
        tmpOptions.push(...MatricPotentialAttribute.getVariables());
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        break;
      case 15:
        tmpOptions.push(...SoilPhAttribute.getVariables());
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        break;
      case 16:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        tmpOptions.push(...SoilEcAttribute.getVariables());
        break;
      case 17:
        tmpOptions.push(...RadiationAttribute.getVariables());
        break;
      case 18:
        tmpOptions.push(...ParFarRedAttribute.getVariables());
        tmpOptions.push(...FarRedAttribute.getVariables());
        break;
      case 19:
        tmpOptions.push(...PriAttribute.getVariables());
        break;
      case 20:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        break;
      case 21:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        break;
      case 22:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        break;
      case 23:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        break;
      case 24:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        break;
      case 25:
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        tmpOptions.push(...SoilEcAttribute.getVariables());
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        break;
      case 26:
        tmpOptions.push(...AirTemperatureAttribute.getVariables());
        tmpOptions.push(...HumidityAttribute.getVariables());
        tmpOptions.push(...AtmPressureAttribute.getVariables());
        tmpOptions.push(...DewPointAttribute.getVariables());
        tmpOptions.push(...DpvAttribute.getVariables());
        break;
      case 27:
        tmpOptions.push(...WaterPluviometerAttribute.getVariables());
        tmpOptions.push(...WaterCounterPulseAttribute.getVariables());
        tmpOptions.push(...CntParcialAttribute.getVariables());
        break;
      case 28:
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        tmpOptions.push(...SoilEcAttribute.getVariables());
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        break;
      case 29:
        tmpOptions.push(...WaterEcAttribute.getVariables());
        tmpOptions.push(...WaterTemperatureAttribute.getVariables());
        break;
      case 30:
        tmpOptions.push(...SoilMoistureAttribute.getVariables());
        tmpOptions.push(...SoilEcAttribute.getVariables());
        tmpOptions.push(...SoilTemperatureAttribute.getVariables());
        break;
      case 31:
        tmpOptions.push(...DepthAttribute.getVariables());
        tmpOptions.push(...WaterTemperatureAttribute.getVariables());
        tmpOptions.push(...WaterEcAttribute.getVariables());
        break;
      case 32:
        tmpOptions.push(...CalWatsAttribute.getVariables());
        break;
      case 33:
        tmpOptions.push(...RadiationAttribute.getVariables());
        break;
      case 34:
        tmpOptions.push(...Co2Attribute.getVariables());
        break;
      case 35:
        tmpOptions.push(...CondAttribute.getVariables());
        tmpOptions.push(...TempAttribute.getVariables());
        break;
      case 36:
        tmpOptions.push(...PhAttribute.getVariables());
        tmpOptions.push(...TempAttribute.getVariables());
        break;
      case 37:
        tmpOptions.push(...MatricPotentialAttribute.getVariables());
        break;
      case 38:
        tmpOptions.push(...MatricPotentialAttribute.getVariables());
        break;
      case 39:
        tmpOptions.push(...MatricPotentialAttribute.getVariables());
        break;
      case 40:
        tmpOptions.push(...RawAttribute.getVariables());
        break;
      case 41:
        tmpOptions.push(...RawAttribute.getVariables());
        break;
      case 42:
        tmpOptions.push(...RawAttribute.getVariables());
        break;
      case 43:
        tmpOptions.push(...WaterCounterPulseAttribute.getVariables());
        break;
      case 44:
        tmpOptions.push(...LeafTemperatureAttribute.getVariables());
        tmpOptions.push(...LeafWetnessAttribute.getVariables());
        break;
      case 45:
        tmpOptions.push(...RadiationAttribute.getVariables());
        break;
      case 46:
        tmpOptions.push(...WindDirectionAttribute.getVariables());
        break;
      case 47:
        tmpOptions.push(...WindSpeedAttribute.getVariables());
        break;
      case 48:
        tmpOptions.push(...PressureAttribute.getVariables());
        break;
      case 49:
        tmpOptions.push(...WaterLevelAttribute.getVariables());
        break;
      case 50:
        tmpOptions.push(...VoltageAttribute.getVariables());
        break;
      case 51:
        tmpOptions.push(...VoltageAttribute.getVariables());
        break;
      case 52:
        tmpOptions.push(...MilliAmpsAttribute.getVariables());
        break;
      case 53:
        tmpOptions.push(...RadiationAttribute.getVariables());
        tmpOptions.push(...WaterAttribute.getVariables());
        tmpOptions.push(...WindSpeedAttribute.getVariables());
        tmpOptions.push(...WindDirectionAttribute.getVariables());
        tmpOptions.push(...AirTemperatureAttribute.getVariables());
        tmpOptions.push(...VaporPressureAttribute.getVariables());
        tmpOptions.push(...AtmPressureAttribute.getVariables());
        tmpOptions.push(...HumidityAttribute.getVariables());
        tmpOptions.push(...PrecipitationECAttribute.getVariables());
        break;



    }

    return tmpOptions;
  }
}